import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckbox = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1,
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 34,
			height: 34,
			rx: 10,
			stroke: "none"
		}), /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 33,
			height: 33,
			rx: 9.5,
			fill: "none"
		})]
	})
});
export default SvgCheckbox;
